var $ = require( "jquery" );
window.jQuery = $; window.$ = $;
// import ModalVideo from 'modal-video';
// import { TimelineMax } from "gsap";
import slick from 'slick-carousel';
// import MiniMasonry from "minimasonry";
// import Macy from "macy";
// import Rellax from "rellax";

// import EmblaCarousel from "embla-carousel";
// import { setupPrevNextBtns, disablePrevNextBtns } from "./components/prevAndNextButtons";
// import { setupDotBtns, generateDotBtns, selectDotBtn } from "./components/dotButtons";
// import { parallax } from "./components/parallax";

// const wrap = document.querySelector(".embla");
// const viewPort = wrap.querySelector(".embla__viewport");
// const prevBtn = wrap.querySelector(".embla__button--prev");
// const nextBtn = wrap.querySelector(".embla__button--next");
// const dots = document.querySelector(".embla__dots");
// const embla = EmblaCarousel(viewPort, { loop: false, dragFree: true });
// const dotsArray = generateDotBtns(dots, embla);
// const setSelectedDotBtn = selectDotBtn(dotsArray, embla);
// const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);
// const applyParallaxStyles = parallax(embla);

// setupPrevNextBtns(prevBtn, nextBtn, embla);
// setupDotBtns(dotsArray, embla);

// embla.on("scroll", applyParallaxStyles);
// embla.on("resize", applyParallaxStyles);

// embla.on("select", setSelectedDotBtn);
// embla.on("select", disablePrevAndNextBtns);
// embla.on("init", setSelectedDotBtn);
// embla.on("init", applyParallaxStyles);
// embla.on("init", disablePrevAndNextBtns);

// import LocomotiveScroll from 'locomotive-scroll';
// const scroll = new LocomotiveScroll({
//     el: document.querySelector('[data-scroll-container]'),
//     smooth: true
// });

// Also can pass in optional settings block
  // var rellax = new Rellax('.rellax', {
  //   speed: -2,
  //   center: false,
  //   wrapper: null,
  //   round: true,
  //   vertical: true,
  //   horizontal: false
  // });

import * as ScrollMagic from "scrollmagic";
import { ScrollMagicPluginIndicator} from "scrollmagic-plugins";
import { TweenMax, TimelineMax } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugins";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
ScrollMagicPluginIndicator(ScrollMagic);

// var rellax = new Rellax('.rellax');



if($(".masonry").length) {
	var macy = Macy({
	    container: '.masonry',
	    trueOrder: true,
	    waitForImages: false,
	    margin: 24,
	    columns: 2,
	    breakAt: {
	        767: 1,
	    }
	});
}

// Mobile Nav
(function() {
	$('#nav-icon3').click(function(){
		$(this).toggleClass('open');
		$('.mobile-nav').toggleClass('on');
		$('body').toggleClass('overflow-hidden');
		$('.icon-search').toggleClass('hidden');

		if ($(this).hasClass('open')) {
			var element = $('header nav').detach();
			$('.mobile-nav').append(element);
		}
		if (!$(this).hasClass('open')) {
			var element = $('.mobile-nav nav').detach();
			$('header > div').append(element);			
			$('header nav ul li').removeAttr('style');
		}


		function mobileMenuAnim() {
		  var mobileMenuItems = document.querySelectorAll('.mobile-nav.on nav ul li');

		  var tl = new TimelineMax();
		      tl.staggerFrom(mobileMenuItems, 0.5, { autoAlpha: 0, y: 10 }, 0.03);
		      // tl.reversed() ? tl.play() : tl.reverse(-0.1);
		}

		mobileMenuAnim();
		// $('header nav').slideToggle();
	});
})();

/*------------------------------------------------------------------------*\
= Intro Anim
\*------------------------------------------------------------------------*/

function loadAnim() {
  // var mask = document.getElementById('mask');
  var logo = document.querySelectorAll('header img');
  var menu = document.querySelectorAll('header nav');
  var social = document.querySelectorAll('header .icon-search');

  var tl = new TimelineMax({ delay: 0.3 });
      // tl.to(mask, 0.5, { x: '100%'}, 'label');
      tl.from(logo, 0.3, { autoAlpha: 0, y: -3 }, 'label+=0.15');
      tl.from([menu, social], 0.3, { autoAlpha: 0 }, 'label+=0.15');
}

// loadAnim();

// Back to top
(function() {
	var controller = new ScrollMagic.Controller();
	// build scene
	new ScrollMagic.Scene({
		triggerElement: "footer",
		triggerHook: 0.65, // show, when scrolled 10% into view
		duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
		offset: 50 // move trigger to center of element
	})
	.setClassToggle(".scroll-up", "visible") // add class to reveal
	// .addIndicators() // add indicators (requires plugin)
	.addTo(controller);

	// Scroll to top//Click event to scroll to top
  $('.back-to-top').on('click', function() {
    $('html, body').animate({
      scrollTop: 0
    }, 800);
    return false;
  });
})();

// Sticky Header
(function() {
	$(document).scroll(function() {
	  $(".page-id-1894 .sticky, .page-id-1906 .sticky, .page-id-1908 .sticky, .page-id-1914 .sticky, .home .sticky").toggleClass("on", $(document).scrollTop() >= 70);
	});
})();

// If no secondary header menu remove hr
(function() {
	if ($('header nav ul li.active a + ul').length) {
			$('header + hr').css('display', 'block');
	}
})();

// Check for Safari
(function() {
	var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	var is_firefox = typeof window.InstallTrigger !== 'undefined';

	if (is_safari || is_firefox) {
		$('body').addClass('is-safari');
	}
})();

// Remove secondary menu underline on hover
// (function() {
// 	$(".menu-item-has-children:not(.current-menu-parent)").hover(function() {
// 		$('nav li.current-menu-item a').toggleClass('off');
// 	});
// })();

// Resize header on scroll
// (function() {
// 	$(window).scroll(function(){
// 		$('.sticky').toggleClass('on', $(this).scrollTop() > 10);
// 	});
// })();

// Set search icon position
(function() {
	$(window).on('load resize', function() {
		// Get left value of logo and align blurb to this
		var offset = $('.sticky header').offset();		
			// console.log(offset)
		// Set element position		
		$('.icon-search').css('right', (offset.left));		

		// Pagination carousel
		// var paginationPos = $('.slider + .controls').offset();
		// $('.pagination.absolute.bottom-10').css('top', (paginationPos.top));	

	})
})();

/*------------------------------------------------------------------------*\
    = Stagger Anim
\*------------------------------------------------------------------------*/

$(function() {
  
  // $('section').each(function (index, elem) {
  //   // Init ScrollMagic Controller
  //   var scrollMagicController = new ScrollMagic.Controller(); 
     
  //   // Create Animations
  //   var el = $(elem).find('h1, .hero p, .hero .btn, h1 + p, h1 + p + p');
    
  //   var tl = new TimelineMax({pause: true});    
  //   tl.add("start") // add timeline label
  //     .staggerTo(el, 1, { y: 0, autoAlpha: 1, ease: "expo.out" }, 1, "start")          
    
  //   // Create the Scene and trigger when visible
  //    var scene = new ScrollMagic.Scene({
  //     triggerElement: elem,
  //     reverse: false,
  //     triggerHook: 0.8,      
  //     offset: 100 /* offset the trigger Npx below scene's top */
  //   })
  //   .setTween(tl)
  //   .on('end', function(){
  //   })
  //   .addTo(scrollMagicController);
  //   // Add debug indicators fixed on right side
  //    // scene.addIndicators(); 
  // });
});

$(function() {
  
  // $('section').each(function (index, elem) {
  //   // Init ScrollMagic Controller
  //   var scrollMagicController = new ScrollMagic.Controller(); 
     
  //   // Create Animations
  //   var elUp = $(elem).find('.anim-1, .anim-2');
    
  //   var tl = new TimelineMax({pause: true});    
  //   tl.add("start") // add timeline label
  //     tl.staggerFrom(elUp, 0.3, { autoAlpha: 0, y: 20 }, 0.2, 'label');
    
  //   // Create the Scene and trigger when visible
  //    var scene = new ScrollMagic.Scene({
  //     triggerElement: elem,
  //     reverse: false,
  //     triggerHook: 0.8,      
  //     offset: 100 /* offset the trigger Npx below scene's top */
  //   })
  //   .setTween(tl)
  //   .on('end', function(){
  //   })
  //   .addTo(scrollMagicController);
  //   // Add debug indicators fixed on right side
  //    // scene.addIndicators(); 
  // });
});

(function() {

  // function elSlider() {
	 //  	if ($('.carousel').length) {
	 //  		$('.carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		// 		var i = (currentSlide ? currentSlide : 0) + 1;
		// 		$('.carousel-current').text( i + ' of ' + slick.slideCount);
		// 	}).slick({
		//           dots : false,
		//           infinite: true,
		//           slidesToShow: 1,
		//           arrows: true,
		//           fade: true,
		//           prevArrow : '.control.prev',
		//           nextArrow : '.control.next',
		//           adaptiveHeight: true,
		//       });
	 //  	}
  // }
  // elSlider();

  function slideMe(name, totalSlideToShow) {
  	if ($(name).length) {
	  	$(name).each(function(key, item) {
	  		var id = $(this).attr("id");
	  		var sliderId = '#' + id;
	  		var arrowPrev = '#' + id + ' + div .prev';
	  		var arrowNext = '#' + id + ' + div .next';
	  		var pagination = $(this).parent().parent().next('.pagination');


	  		// alert(arrowNext);
	  		// console.log(sliderId);

	  		$(sliderId).on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// $('.title-h2 > div').fadeOut();
			}).on('afterChange', function(event, slick, currentSlide, nextSlide){
				// $('.title-h2 > div').fadeIn();
			}).slick({
				  appendDots : pagination,
				  // appendDots : ".pagination",
				  dots : true,
		          infinite: true,
		          slidesToShow: totalSlideToShow,
							// slidesToShow: 3,
							centerMode: false,
							// centerPadding: '20%',
		          waitForAnimate: false,
		          arrows: true,
		          fade: false,
		          prevArrow : (arrowPrev),
		          nextArrow : (arrowNext),
		          adaptiveHeight: true,
		          swipe: true,
		          swipeToSlide: true,
		          edgeFriction: 0,
		          touchThreshold: 4,
		          touchMove: true,
		          responsive: [
			      		{
			      			breakpoint: 960,
			      			settings: {
			      				slidesToShow: 2
			      		}
		          	},
		          	{
			      			breakpoint: 767,
			      			settings: {
			      				slidesToShow: 1
			      		}
		          	},
		          ]
			});
	  	});
  		}
	}

	slideMe('.slider', 2);
	slideMe('.slider-2', 4);
	
	// Timeline carousel
	if ($('.slider-3').length) {
	  	$('.slider-3').each(function(key, item) {
	  		var id = $(this).attr("id");
	  		var sliderId = '#' + id;
	  		var arrowPrev = '#' + id + ' + div .prev';
	  		var arrowNext = '#' + id + ' + div .next';
	  		var pagination = $(this).parent().parent().next('.pagination');

	  		// alert(arrowNext);
	  		// console.log(sliderId);

	  	

	  		$(sliderId).on('init', function(event, slick, currentSlide, nextSlide){				
					$('.timeline + .controls .btn.prev').addClass('off');				
				}).on('afterChange', function(event, slick, currentSlide, nextSlide){				
					$('.timeline + .controls .btn.prev').removeClass('off');
					$('.timeline').parent().parent().removeClass('w-screen');
						
						// Remove overflow hidden if on last slide
						var itemLength = $('.timeline .slick-track > div').length;						

						console.log(currentSlide)
						console.log(itemLength)
												
						// if(currentSlide == itemLength) {
						// 	$('.timeline').parent().parent().removeClass('w-screen');
						// 	$('.timeline + .controls .btn.next').addClass('off');
						// } else {
						// 	$('.timeline').parent().parent().addClass('w-screen');
						// 	$('.timeline + .controls .btn.next').removeClass('off');
						// }

						if(currentSlide == 0) {
							$('.timeline + .controls .btn.prev').addClass('off');
							$('.timeline').parent().parent().addClass('w-screen');
						} else {
							$('.timeline + .controls .btn.prev').removeClass('off');
						}

			}).slick({
				  appendDots : pagination,
				  // appendDots : ".pagination",
				  dots : true,
          infinite: false,
          slidesToShow: 6,
					// slidesToShow: 3,
					centerMode: false,
					// centerPadding: '20%',
          waitForAnimate: false,
          arrows: true,
          fade: false,
          prevArrow : (arrowPrev),
          nextArrow : (arrowNext),
          adaptiveHeight: true,
          swipe: true,
          swipeToSlide: true,
          edgeFriction: 0,
          touchThreshold: 4,
          touchMove: true,
          responsive: [
              {
                      breakpoint: 3000,
                      settings: {
                          slidesToShow: 7
                      }
              },
							{
                      breakpoint: 2700,
                      settings: {
                          slidesToShow: 6
                      }
              },
              {
                      breakpoint: 2400,
                      settings: {
                          slidesToShow: 5
                      }
              },
               {
                      breakpoint: 1900,
                      settings: {
                          slidesToShow: 4
                      }
              },
              {
                      breakpoint: 1440,
                      settings: {
                          slidesToShow: 3
                      }
              },
              {
                      breakpoint: 960,
                      settings: {
                          slidesToShow: 2
                      }
              },
              {
                      breakpoint: 767,
                      settings: {
                          slidesToShow: 1
                  }
              },
          ]
			});
	  	});
}

// $('.slider-3 .slick-list > div > div:last-child').clone().appendTo('.slider-3 .slick-list .slick-track');


	(function () {
	    $('.mobile-menu').find('.menu-item-has-children').append('<span class="icon"></span>');
	    $('.mobile-menu .menu-items .icon').click(function() {	    		
	    		$(this).toggleClass('active');
	    		$(this).parent().find('.sub-menu').slideToggle();
	    		$(this).parent().nextAll().find('.sub-menu').slideUp();
	    		$(this).parent().nextAll().find('.icon').removeClass('active');
	    		$(this).parent().prevAll().find('.sub-menu').slideUp();
	    		$(this).parent().prevAll().find('.icon').removeClass('active');
	    		$(this).parent().toggleClass('active');
	    		$(this).parent().nextAll().removeClass('active');
	    		$(this).parent().prevAll().removeClass('active');
	    });

	    $(document).scroll(function() {
			  $("header").toggleClass("sticky-header", $(document).scrollTop() >= 70);
			  $("#nav-icon3, .icon-search path").toggleClass("on", $(document).scrollTop() >= 70);
			});
	})();
	


	/* Mobile menu */
	$('.menu-icon').click(function() {
	  $(this).toggleClass('on');
	  $('.mobile-menu').slideToggle();
	  $('body').toggleClass('overflow active-nav');
	  $('header .logo').toggleClass('off');

	  $('.sticky-header').toggleClass('off');
	});

	$('.mobile-menu').find('.icon-toggle').click(function() {
	  $(this).parent().toggleClass('on');
	  $(this).next('ul').slideToggle();
	});

	// $('.search.btn, .search-icon').click(function() {
	// 	$('.modal').slideToggle(300);
	// 	$('.menu-dropdown-wrap > ul').toggleClass('on');
	// 	$(this).toggleClass('active');
	// 	$('.logo').toggleClass('color');
	// });

(function () {
	// var tl = new TimelineMax({ delay: 0.2 });
		var tl = new TimelineMax({ paused: true, reversed: true });
      	tl.to('.search-container form', 0.5, { y: 20}, 'label');      
      	// tl.reversed() ? tl.play() : tl.reverse(-0.1);

	$('.icon-search').click(function() {		
		$(this).toggleClass('on');
		$('body').toggleClass('overflow-hidden');
		$('header nav').toggleClass('off');
		$('.search-container').slideToggle(400);
		
    tl.reversed() ? tl.play() : tl.reverse();
	});	

    function sizeUpdate() {
      var width = $(window).width(); // Get window width
      var height = $(window).height(); // Get window height

      if (width > 1280) {
    //     $("nav ul li.menu-item-has-children").hover(function(){
				//   $(this).prevAll('li').find('ul').css('visibility', 'hidden');
				//   $(this).nextAll('li').find('ul').css('visibility', 'hidden');
				//   }, function() {
				//   $(this).prevAll('li').find('ul').css('visibility', 'inherit');
				//   $(this).nextAll('li').find('ul').css('visibility', 'inherit');
				// });
      } 
    };

    $(document).ready(sizeUpdate); // When the page first loads
    $(window).resize(sizeUpdate); // When the browser changes size	
})();

	// Drop down
	$("ul.menu > li").hover(function () {
	    $('body').toggleClass('hover-active');
	 });

	// Accordion
	$('.accordion .title').click(function() {
		$(this).next('ul').slideToggle();
		$(this).toggleClass('on');
	});

		$('.back-top').click(function() {
      $('html, body').animate({
        	scrollTop: $("body").offset().top
    		}, 900);
      });

	// Add class to secondary menu if list items exist
	if( ($("ul#sec-nav").has("li").length === 0) ) {
		$("ul#sec-nav").hide();
	} else {
	  //$("ul#sec-nav").addClass('py-12');
	}

	$(".datepicker" ).datepicker({
			dateFormat : "yy-mm-dd",
			changeYear: true,
			changeMonth: true
	});

// Add class to all links with hashes
$('div').each(function() {
	var attr = $(this).attr('id');
		if (attr) {
			$(this).addClass('anchor');
		}
});
	// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        }); 
      }
    }
  });

  // Add class if total item is less than 4
  $('.slick-track').each(function() {
  	var totalItem = $(this).children().length;
  	if (totalItem < 4) {
  		$('.slick-track').addClass('on');
  	}
  });
  
  


	/**
	* jquery.matchHeight-min.js v0.5.2
	* http://brm.io/jquery-match-height/
	* License: MIT
	*/
	(function(b){b.fn.matchHeight=function(a){if("remove"===a){var d=this;this.css("height","");b.each(b.fn.matchHeight._groups,function(b,a){a.elements=a.elements.not(d)});return this}if(1>=this.length)return this;a="undefined"!==typeof a?a:!0;b.fn.matchHeight._groups.push({elements:this,byRow:a});b.fn.matchHeight._apply(this,a);return this};b.fn.matchHeight._apply=function(a,d){var c=b(a),e=[c];d&&(c.css({display:"block","padding-top":"0","padding-bottom":"0","border-top-width":"0","border-bottom-width":"0",
	height:"100px"}),e=k(c),c.css({display:"","padding-top":"","padding-bottom":"","border-top-width":"","border-bottom-width":"",height:""}));b.each(e,function(a,c){var d=b(c),e=0;d.each(function(){var a=b(this);a.css({display:"block",height:""});a.outerHeight(!1)>e&&(e=a.outerHeight(!1));a.css({display:""})});d.each(function(){var a=b(this),c=0;"border-box"!==a.css("box-sizing")&&(c+=g(a.css("border-top-width"))+g(a.css("border-bottom-width")),c+=g(a.css("padding-top"))+g(a.css("padding-bottom")));
	a.css("height",e-c)})});return this};b.fn.matchHeight._applyDataApi=function(){var a={};b("[data-match-height], [data-mh]").each(function(){var d=b(this),c=d.attr("data-match-height");a[c]=c in a?a[c].add(d):d});b.each(a,function(){this.matchHeight(!0)})};b.fn.matchHeight._groups=[];b.fn.matchHeight._throttle=80;var h=-1,f=-1;b.fn.matchHeight._update=function(a){if(a&&"resize"===a.type){a=b(window).width();if(a===h)return;h=a}-1===f&&(f=setTimeout(function(){b.each(b.fn.matchHeight._groups,function(){b.fn.matchHeight._apply(this.elements,
	this.byRow)});f=-1},b.fn.matchHeight._throttle))};b(b.fn.matchHeight._applyDataApi);b(window).bind("load resize orientationchange",b.fn.matchHeight._update);var k=function(a){var d=null,c=[];b(a).each(function(){var a=b(this),f=a.offset().top-g(a.css("margin-top")),h=0<c.length?c[c.length-1]:null;null===h?c.push(a):1>=Math.floor(Math.abs(d-f))?c[c.length-1]=h.add(a):c.push(a);d=f});return c},g=function(a){return parseFloat(a)||0}})(jQuery);

	$('.equal').matchHeight();

		let url = window.location.href;
		if(url.includes('?')){
		  	$('#featured').hide();
		    $('.results').text('Results');
		}

	/**
	* FacetWP 
	*/
	 	$(document).on('facetwp-loaded', function() {

      var searchfacet = 'search_publications'; 
      var searchbox = $('[data-name="' + searchfacet + '"] .facetwp-search');
      var dropdownbox = $('.facetwp-facet-categories .facetwp-dropdown');
      var selected_text = $('.facetwp-facet-categories .facetwp-dropdown :selected').text();

      if ('undefined' !== typeof FWP.facets['search_publications'] && FWP.facets['search_publications'].length > 0) {
      		$('#featured').slideUp(300);
		     	$('.results').text('Results');
      }

      if ('undefined' !== typeof FWP.facets['categories'] && FWP.facets['categories'].length > 0 ) {
          $('#featured').slideUp(300);
		     	$('.results').text('Results');
	    } 

      if(! searchbox.next('i').length) {
        searchbox.after('<i class="clear" title="Clear Search"></i>');
      }

      if (searchbox.val() === '') {
        searchbox.next().hide();
      }

      searchbox.on('keyup', function() {
        if('yes' === FWP.settings[searchfacet]['auto_refresh']) {
          $(this).addClass('loading');
        }
        if ($(this).val() !== '') {
          $(this).next().show();
        }
      });

      searchbox.removeClass('loading');

      searchbox.next().click(function() {
        // ignore while Search facet is loading
        if (!searchbox.prev().hasClass('f-loading')) {

          FWP.is_reset = true;
       	 	FWP.facets['categories'] = []; // set other facet to no selections
       	 	delete FWP.facets['paged']; // remove "paged" from URL
       	 	FWP.refresh();

       	 	$(this).hide();
          searchbox.val('');

       	 	$('#featured').slideDown(200);
			    $('.results').text('New');


          if (FWP.facets[searchfacet].length) {
            FWP.autoload();
          }
        }
      });

      $(document).on('change', '.facetwp-facet-categories .facetwp-dropdown', function() { 

      	var selected_option = dropdownbox.val();
      	var selected_text = $('.facetwp-facet-categories .facetwp-dropdown :selected').text();

      	if (selected_text === 'All Publications') {
		      	$('#featured').slideDown(200);
		      	$('.results').text('New');
		     } else {
		     		$('#featured').slideUp(300);
		     		$('.results').text('Results');
		     }
      });

    });

	})();

(function () {
	$('select').each(function(){
    var $this = $(this), numberOfOptions = $(this).children('option').length;
  
    $this.addClass('select-hidden'); 
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());
  
    var $list = $('<ul />', {
        'class': 'select-options'
    }).insertAfter($styledSelect);
  
    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val()
        }).appendTo($list);
        //if ($this.children('option').eq(i).is(':selected')){
        //  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
        //}
    }
  
    var $listItems = $list.children('li');
  
    $styledSelect.click(function(e) {
        e.stopPropagation();
        $('div.select-styled.active').not(this).each(function(){
            $(this).removeClass('active').next('ul.select-options').hide();
        });
        $(this).toggleClass('active').next('ul.select-options').toggle();
    });
  
    $listItems.click(function(e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass('active');
        $this.val($(this).attr('rel'));
        $list.hide();
        //console.log($this.val());
    });
  
    $(document).click(function() {
        $styledSelect.removeClass('active');
        $list.hide();
    });

});
})();


